export const enum SUMMARY_STATUS {
    INITIAL,
    WAITING_FOR_START,
    SUMMARIZING,
    STOPPING,
}
